import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Avatar = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 50%;
  background-size: 70%;
  background-color: ${props => props.theme.colors.primary};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  border: 2px solid #fff;
  cursor: pointer;
  overflow: hidden;
  img {
    max-width: 100%;
  }
`;

export const Meta = styled(Flex).attrs({
  column: true,
  justify: 'center',
})`
  color: #cacaca;
  font-size: 12px;
  margin-top: 1px;
  line-height: 12px;
`;

export const Name = styled.span`
  color: ${props => props.theme.colors.primary};
  font-size: 14px;
`;
